// import React from "react";
// import { NavLink } from "react-router-dom";
// import { LogOut, User, LayoutDashboard, Users } from "lucide-react";
// import logo from "../assets/LogoIcon.png";

// export default function Sidebar({ sidebarOpen, setSidebarOpen, onDownloadCSV, onLogout }) {
//   const role = localStorage.getItem("role");
//   const email = localStorage.getItem("email") || "admin@test.com";

//   return (
//     <div
//       className={`fixed top-0 left-0 h-full w-64 border-r shadow-lg
//       transform transition-transform duration-300 z-50 flex flex-col
//       ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}`}
//       style={{ backgroundColor: "#EAF7EE" }}
//     >

//       {/* Logo Header */}
//      {/* Logo Header */}
// <div className="flex items-center justify-between p-4 border-b border-green-200">
//   <div className="flex items-center gap-2">
//     <img src={logo} alt="20fy Logo" className="w-8 h-8 object-contain" />
//     <h2 className="font-bold text-lg text-gray-800">20fy.ai</h2>
//   </div>
// <button
//   onClick={() => setSidebarOpen(false)}
//   className="md:hidden text-gray-600 hover:text-gray-800 transition-colors text-xl"
// >
//   ✕
// </button>
// </div>

//       {/* Nav Links */}
//       <nav className="p-4 space-y-2 flex-1">

//         <NavLink
//           to="/dashboard"
//           className={({ isActive }) =>
//             `flex items-center gap-3 px-4 py-2.5 rounded-lg transition-all duration-200 text-sm font-medium ${
//               isActive
//                 ? "bg-green-700 text-white shadow-md"
//                 : "text-green-900 hover:bg-green-200 hover:text-green-800"
//             }`
//           }
//         >
//           <LayoutDashboard size={17} />
//           Dashboard
//         </NavLink>

//         <NavLink
//           to="/users"
//           className={({ isActive }) =>
//             `flex items-center gap-3 px-4 py-2.5 rounded-lg transition-all duration-200 text-sm font-medium ${
//               isActive
//                 ? "bg-green-700 text-white shadow-md"
//                 : "text-green-900 hover:bg-green-200 hover:text-green-800"
//             }`
//           }
//         >
//           <Users size={17} />
//           Customers
//         </NavLink>

//       </nav>

//       {/* Footer - User Info + Logout */}
//       <div className="p-4 border-t border-green-200 bg-green-50 space-y-3">

//         {/* User Info */}
//         <div className="flex items-start gap-2">
//           <div className="w-8 h-8 rounded-full bg-green-700 flex items-center justify-center flex-shrink-0">
//             <User size={15} className="text-white" />
//           </div>
//           <div className="min-w-0">
//             <span className="px-2 py-0.5 bg-green-700 text-white text-xs font-bold rounded">
//               {role}
//             </span>
//             <p className="text-xs text-green-800 truncate mt-1">
//               {email}
//             </p>
//           </div>
//         </div>

//         {/* Logout Button */}
//         <button
//           onClick={onLogout}
//           className="w-full text-sm text-red-700 py-2 rounded-lg border border-red-200 bg-white hover:bg-red-50 transition-colors flex items-center justify-center gap-2 font-medium"
//         >
//           <LogOut size={16} className="text-red-700" />
//           Logout
//         </button>

//       </div>
//     </div>
//   );
// }



//old version 



import React from "react";
import { NavLink } from "react-router-dom";
import { LogOut, User } from "lucide-react";
import logo from "../assets/LogoIcon.png";

export default function Sidebar({ sidebarOpen, setSidebarOpen, onDownloadCSV, onLogout }) {
  const role = localStorage.getItem("role");
  const email = localStorage.getItem("email") || "admin@test.com";

  return (
   <div
  className={`fixed top-0 left-0 h-full w-64 border-r shadow-lg
  transform transition-transform duration-300 z-50 flex flex-col
  ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}`}
  style={{ backgroundColor: "#EAF7EE" }}
>

<div className="flex items-center justify-between p-4 border-b">
  
  <div className="flex items-center gap-2">
    <img src={logo} alt="20fy Logo" className="w-8 h-8 object-contain" />
    <h2 className="font-bold text-lg">20fy.ai</h2>
  </div>

  <button
    onClick={() => setSidebarOpen(false)}
    className="text-xl"
  >
    ✕
  </button>

</div>

      <nav className="p-4 space-y-3 flex-1">

        <NavLink 
          to="/dashboard" 
         className={({ isActive }) =>
  `block px-4 py-2 rounded-lg transition-all duration-200 ${
    isActive
      ? "bg-green-100 text-green-700 font-semibold shadow-sm"
      : "text-gray-700 hover:bg-green-100 hover:shadow-md"
  }`
}
        >
          Dashboard
        </NavLink>

        <NavLink 
          to="/users" 
          className={({ isActive }) =>
            `block px-4 py-2 rounded-lg transition-colors ${
              isActive
                ? "bg-green-100 text-green-700 font-semibold"
                : "text-gray-700 hover:bg-gray-100"
            }`
          }
        >
          Customers
        </NavLink>

      </nav>

<div className="p-4 border-t space-y-3 bg-gray-50 rounded-lg border border-gray-200">

  {/* User Role Display */}
<div>
  {/* Icon + Role */}
  <div className="flex items-center gap-2 mb-1">
    <User size={16} className="text-gray-600" />
    <span className="px-2 py-1 bg-green-100 text-green-700 text-xs font-bold rounded">
      {role}
    </span>
  </div>

  {/* Email */}
  <p className="text-xs text-gray-500 truncate">
    {email}
  </p>
</div>

  {/* Logout Button */}
  <button
    onClick={onLogout}
    className="w-full text-base  text-red-800 py-2 rounded-md border  hover:bg-red-50 transition-colors flex items-center justify-center gap-2"
  >
    <LogOut size={18} className="text-red-800" />
    Logout
  </button>

</div>
    </div>
  );
}
